import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'

import user from './user'
import notifications from './notifications'
import partCategories from './partCategories'
import parts from './parts'
import partsErrors from './partsErrors'
import attributes from './attributes'
import ui from './ui'
import instructions from './instructions'
import filter from './filter'
import formula from './formula'
import activity from './activity'

const api = {
  state: {
    site: process.env.VUE_APP_SITE_HOST,
    host: process.env.VUE_APP_API_HOST,
    siteUrl: process.env.VUE_APP_SITE_URL,
    endpoint: {
      login: '/user/login',
      userCurrent: '/user/current',
      part_categories: '/part-categories',
      part_categories_schema: '/part-categories/schema',
      parts: '/parts',
      attributes: '/attributes',
      attributesTypes: '/attributes/types',
      loadImg: '/part-images',
      sendImg: '/part-images',
      getImgCount: '/part-images/counts-in-category',
      instruction: '/instructions',
      imagesInstruction: '/instruction-images',
      instructionTypes: '/instructions/element-types',
      userSettings: '/user/settings',
      roles: '/invites/roles',
      invites: '/invites',
      users: '/users',
      formula: '/params-config',
      activity: '/activity'
    }
  }
}

export default createStore({
  modules: {
    api,
    user,
    notifications,
    partCategories,
    parts,
    partsErrors,
    attributes,
    ui,
    instructions,
    filter,
    formula,
    activity
  },
  plugins: [
    createPersistedState({
      key: 'data',
      paths: ['user.userInfo', 'user.accesToken']
    })
    // createPersistedState({
    //   key: 'tables',
    //   paths: ['ui.tables']
    // })
  ]
})
